import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";

export default class MessageA1i extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
    console.log(this.props,"a1i props");
    if(this.props.disabled){
      var a = document.getElementsByClassName("ImageWithButton");
      for (var i = 0; i < a.length; i++) {
        a[i].style.pointerEvents = "none";
        a[i].style.opacity = "0.5";
      }
    }
  }
  text = (this.props.entry && this.props.entry.text) || "";
  imgUrl = (this.props.entry && this.props.entry.url) || "";

  handleClick = () => {
    this.props.actions.sendMessageWithCode(this.props.entry.keyword, this.text);
    var a = document.getElementsByClassName("ImageWithButton");
    for (var i = 0; i < a.length; i++) {
      a[i].style.pointerEvents = "none";
      a[i].style.opacity = "0.5";
    }
  };
  messageContainerStyle = () => {
    // let nextDiv = document.getElementById("ImageWithButtonId").nextSibling;
    const showColumn = s360ConfigService?.config?.configDetails?.A1iInColumn || false
    return {
      opacity: this.props.disabled ? 0.5 : 1,
      width: this.props.A1iCount === 4 ? "36%" : "25%",
      pointerEvents:this.props.disabled ? 'none' :'all',
      marginLeft: localStorage.getItem("openInFullScreen") ? '4%' : '6%',
      marginBottom: localStorage.getItem("openInFullScreen") ? '4%' : '2%',
      padding: showColumn ? '0%' : '3%',
      flexDirection: showColumn ? 'column' : 'row',
    };
  };
  render() {
    return (
      <div
        className="ImageWithButton"
        id="ImageWithButtonId"
        onClick={this.handleClick}
        style={this.messageContainerStyle()}
      >
        {s360ConfigService?.config?.configDetails?.A1iInColumn
          ? 
            <>
              <div>{this.imgUrl && <img src={this.imgUrl} style={{ objectFit: 'contain', margin: 0 }}></img>}</div>
              <div><p style={{ textAlign:'center', fontSize: '11px', margin: 0 }}>{this.text}</p></div>
            </>
          :
            <>
              {this.imgUrl && <img height={"40px"} width={"40px"} src={this.imgUrl}></img>}
              <p>{this.text}</p>
            </>
        }       
      </div>
    );
  }
}
